import { StyleSheet } from 'react-native';
import { colors, fonts } from 'src/constants/theme';
import { isWeb } from 'src/utils';

const styles = StyleSheet.create({
  checkIconWrapper: {
    backgroundColor: 'transparent',
    width: 30,
    justifyContent: 'center',
    alignItems: 'center',
  },
  selected: {
    fontSize: 14,
    fontFamily: fonts.regular,
    marginRight: 10,
  },
  actionMenu: {
    borderRadius: 5,
    marginTop: 40,
    overflow: 'hidden',
    shadowColor: colors.grey6,
    shadowRadius: 25,
    shadowOpacity: 1,
    shadowOffset: {
      width: 0,
      height: 0,
    },
  },
  actionItem: {
    width: isWeb() ? 200 : 'auto',
    minWidth: 100,
    maxWidth: 200,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: 5,
  },
  labelWrapper: {
    flexShrink: 1,
    flexGrow: 1,
    flexWrap: 'wrap',
  },
  all: {
    paddingHorizontal: 20,
    alignItems: 'center',
    justifyContent: 'center',
  },
  headerWrapper: {
    justifyContent: 'space-between',
    alignItems: 'center',
    marginHorizontal: 20,
    marginTop: 20,
  },
  toggleContainer: {
    marginTop: 10,
    marginBottom: 20,
  },
  contentContainer: {
    flexGrow: 1,
  },
  title: {
    fontWeight: '800',
  },
  list: {
    flexGrow: 1,
    flexBasis: 1,
  },
  container: {
    paddingVertical: 24,
  },
  logoutBtn: {
    marginLeft: 6,
  },
});

export default styles;
